import { LitElement, html } from 'lit-element';
import uiuxLogo from '../assets/uiuxguidelogo.webp';
import './BottomTray';

class AppHeader extends LitElement {
    static get properties() {
        return {
            activePage: { type: String },
            content: { type: Array }
        };
    }

    createRenderRoot() {
        return this; // Use light DOM instead of shadow DOM
    }

    toggleMenu() {
        const bottomTray = document.querySelector('bottom-tray');
        if (bottomTray) {
            bottomTray.toggle();

            // Create or toggle overlay
            let overlay = document.querySelector('.tray-overlay');
            if (!overlay) {
                overlay = document.createElement('div');
                overlay.className = 'tray-overlay';
                // Insert overlay before the bottom tray to ensure proper stacking
                document.body.insertBefore(overlay, bottomTray);

                // Add click handler to close tray when overlay is clicked
                overlay.addEventListener('click', () => {
                    bottomTray.close();
                    overlay.classList.remove('open');
                });
            }

            if (bottomTray.isOpen) {
                overlay.classList.add('open');
            } else {
                overlay.classList.remove('open');
            }
        }
    }

    render() {
        return html`
            <div class="header-container">
                <div class="logo" tabindex="0" aria-label="Academy Logo">
                    <img src="${uiuxLogo}" alt="UI UX Guide Logo" />
                </div>
                <div class="right-side">
                    <a
                        href="https://akritisingh.com"
                        class="external-link"
                        tabindex="0"
                        aria-label="External Link"
                        target="_blank"
                        rel="noopener"
                        >My Portfolio</a
                    >

                    <!-- Add hamburger menu here -->
                    <button
                        class="hamburger-menu"
                        aria-label="Hamburger Menu"
                        aria-expanded="false"
                        @click=${this.toggleMenu}
                    >
                        <span class="hamburger-icon">
                            <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M20 7L4 7" stroke="#54c4b3" stroke-width="1.5" stroke-linecap="round" />
                                <path d="M20 12L4 12" stroke="#54c4b3" stroke-width="1.5" stroke-linecap="round" />
                                <path d="M20 17L4 17" stroke="#54c4b3" stroke-width="1.5" stroke-linecap="round" />
                            </svg>
                        </span>
                    </button>
                </div>
            </div>

            <bottom-tray .content=${this.content} .activePage=${this.activePage}></bottom-tray>
        `;
    }
}

customElements.define('app-header', AppHeader);
